/* eslint-disable no-redeclare */
import type { FeaturedAds } from '@hc-frontend/core-types';
import {
  Integer,
  Prospect,
  Url,
  USAStateAcronym,
} from '@hc-frontend/core-types';
import type { IOperationResult } from '@hc-frontend/core-utils-business-operation';
import { z } from 'zod';

export const AdButlerAdDto = z.object({
  banner_id: z.string(),
  width: z.string(),
  height: z.string(),
  alt_text: z.string(),
  accompanied_html: z.string(),
  target: z.string(),
  tracking_pixel: z.string(),
  body: z.string(),
  redirect_url: Url.or(z.string()),
  refresh_url: Url.or(z.string()),
  rct: z.string(),
  rcb: z.string(),
  refresh_time: z.string(),
  placement_id: z.string(),
  user_frequency_views: z.string(),
  user_frequency_start: z.string(),
  user_frequency_expiry: z.string(),
  viewable_url: Url.or(z.string()),
  eligible_url: Url.or(z.string()),
  image_url: Url.or(z.string()),
  impressions_remaining: Integer,
  has_quota: z.boolean(),
});

export const AdButlerAdBodyDto = z.object({
  title: z.string(),
  template: z.string(),
  subtitle: z.string(),
  imageUrl: Url,
  displayUrl: z.string(),
  ADVERTISER_ID: z.string(),
  ADVERTISER_NAME_ENCODED: z.string(),
  CAMPAIGN_ID: z.string(),
  CAMPAIGN_NAME_ENCODED: z.string(),
  CPC: z.string(),
  CPM: z.string(),
});

export type AdButlerAd = z.infer<typeof AdButlerAdDto>;

export const FetchAdButlerResponseDto = z
  .object({
    status: z.enum(['SUCCESS']),
    placements: AdButlerAdDto.array(),
  })
  .or(z.object({ status: z.enum(['NO_ADS']), placements: z.object({}) }));

export type FetchAdButlerResponseDto = z.infer<typeof FetchAdButlerResponseDto>;

export const FetchAdButlerRequestDto = z.object({
  ID: z.string(),
  setID: z.string(),
  type: z.literal('jsonr'),
  _abdk_json: z.object({
    state: USAStateAcronym.optional(),
  }),
  customParam1: z.string().optional(),
  customParam2: z.string().optional(),
  customParam3: z.string().optional(),
  customParam4: z.string().optional(),
  customParam5: z.string().optional(),
});

export type FetchAdButlerRequestDto = z.infer<typeof FetchAdButlerRequestDto>;

export const GetAdButlerAdsParams = z.object({
  prospect: Prospect,
  adbutlerId: z.string(),
  adbutlerSetId: z.string(),
  sessionId: z.string(),
  userId: z.string(),
});

export type GetAdButlerAdsParams = z.infer<typeof GetAdButlerAdsParams>;

export type GetAdButlerAdsResult = (
  params: GetAdButlerAdsParams,
) => Promise<IOperationResult<FeaturedAds, 'failedToGetAdButlerAds'>>;
